<template>
    <div class="btn-confirm-main-symptom-wrapper">
        <v-btn
            v-if="isVisible"
            @click="confirmSelectedMainSymptom()"
            :disabled="crtSelectedMainSymptom === null
                || typeof crtSelectedMainSymptom.code === 'undefined'
                || crtSelectedMainSymptom.code.length < 1"
            :id="'btnConfirmMainSymptom' + (symptomSourceType === 'SEARCH' ? 'Search' : 'ChapterTree')"
            color="primary"
            class="btn"
            block>
            {{text("api.chatbot.btn.confirm")}}
        </v-btn>

    </div>
</template>

<!-- ################################################################## -->

<script>

import {mapGetters} from 'vuex';

export default {
    name: 'BtnConfirmMainSymptom',
    props: {
        isVisible: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        crtSelectedMainSymptom: {
            type: Object,
            default: null
        },
        symptomSourceType: { // Can be: "SEARCH" or "CHAPTER_TREE"
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isConfirmBtnLocked: false, // This will help us to prevent multiple clicks on Confirm button.
        }
    },

    computed: {
        ...mapGetters({
            getChapterTree: 'ChatBotStore/getChapterTree',
        })
    },

    mounted() {
        this.isConfirmBtnLocked = false;
    },


    methods: {

        confirmSelectedMainSymptom () {

            if (this.crtSelectedMainSymptom === null
                    || typeof this.crtSelectedMainSymptom.code !== 'string'
                    || typeof this.crtSelectedMainSymptom.name === 'undefined') {
                return;
            }

            if (this.isConfirmBtnLocked === true) {
                return; // Clicks on Confirm button are disabled, so do nothing else.
            }
            else {
                this.isConfirmBtnLocked = true; // Clicks on Confirm button were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
            }

            // If there is a pre-filled "mainSymptomCode" field that came from the server, we know we are in edit mode.
            let isEditMode = (this.getChapterTree.mainSymptomCode !== null) ? true : false;

            // Set the flag to don't scroll to bottom new content at Edit
            if (isEditMode === true) {
                this.$store.commit('ChatBotStore/setIsEditAction', true);
            }

            let symptomCode = this.crtSelectedMainSymptom.code;
            let symptomName;
            if (typeof this.crtSelectedMainSymptom.name === 'string') {
                symptomName = this.crtSelectedMainSymptom.name;
            }
            else if (typeof this.crtSelectedMainSymptom.name === 'object'
                && typeof this.crtSelectedMainSymptom.name.text === 'string') {
                symptomName = this.crtSelectedMainSymptom.name.text;
            }

            let chooseMainSymptomParams = {};
            chooseMainSymptomParams.symptom = {};
            chooseMainSymptomParams.symptom.code = symptomCode;
            chooseMainSymptomParams.symptom.name = symptomName;
            if (isEditMode) {
                chooseMainSymptomParams.edit = true;
            }

            this.$store.dispatch("ChatBotStore/chooseMainSymptom", chooseMainSymptomParams).then(() => {

                this.$store.commit("ChatBotStore/setMustShowChooseMainSymptomPopup", false);
                this.isConfirmBtnLocked = false;

                if (isEditMode) {
                    this.$store.commit("ChatBotStore/clearChapterTree");

                    this.PfChatbotPlugin.handleOnAnswerListUpdated();
                }
            });

            this.$emit('onMainSymptomConfirmed', this.crtSelectedMainSymptom);
        },

    }
}

</script>

<!-- ################################################################## -->

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/main-symptom-popup/BtnConfirmMainSymptom.vue